// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Grace_ListResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Grace_ListResponse — full grace-periods roster.
 * Used by GET /subscriptions/grace/list.
 */
import type { Grace_PeriodRow } from './Grace_PeriodRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Grace_ListResponseDados {
rows: Grace_PeriodRow[]
}

export type Grace_ListResponse = ApiResponse<Grace_ListResponseDados>;

registerResponseContract('Grace_ListResponse', {
  rows: {
    type: 'array',
    required: true,
    items: {
      grace_id:        { type: 'number',  required: true },
      franquia_id:     { type: 'number',  required: true },
      franchise_name:  { type: 'string',  required: false },
      subscription_id: { type: 'number',  required: false },
      plan_id:         { type: 'number',  required: false },
      plan_name:       { type: 'string',  required: false },
      starts_at:       { type: 'string',  required: false },
      ends_at:         { type: 'string',  required: false },
      source:          { type: 'string',  required: false },
      granted_by:      { type: 'string',  required: false },
      reason:          { type: 'string',  required: false },
      revoked_at:      { type: 'string',  required: false },
      revoked_by:      { type: 'string',  required: false },
      is_live:         { type: 'boolean', required: false },
      days_remaining:  { type: 'number',  required: false },
    },
  },
})
